/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { FilterableByYMM, YMMSelectorOptions } from '../interface/models';

export const isYMMSelectorMatching = <T extends FilterableByYMM>(
  cmsItem: T,
  ymmSelectorOptions: YMMSelectorOptions,
): boolean => {
  if (!cmsItem.ymm_filter || !cmsItem.ymm_selector.selectedItems) {
    return false;
  }

  const { allMakes, allModels, allYears } = cmsItem.ymm_selector;
  const { make: currentMake, model: currentModel, year: currentYear } = ymmSelectorOptions;

  if (allMakes && currentMake) {
    if (!currentModel && !currentYear) {
      return true;
    }

    if (allModels && currentModel) {
      if (!currentYear) {
        return true;
      }

      if (allYears && currentYear) {
        return true;
      }
    }
  }

  const matches = cmsItem.ymm_selector.selectedItems.some((ymmSelector) => {
    const make = ymmSelector.make?.label || null;
    const model = ymmSelector.model?.label || null;
    const year = ymmSelector.year?.label || null;

    if (!make) {
      return false;
    }

    return (
      (make === currentMake && model === currentModel && year === currentYear) ||
      (make === currentMake && model === currentModel && currentYear && allYears) ||
      (make === currentMake && currentModel && allModels && !currentYear)
    );
  });

  return matches;
};
